/* eslint-disable */
// 公共参数
function mCommonParams() {
  
  const Info = fund.getUserInfoSync();
  const { userInfo } = Info;
  console.log(userInfo);
  
  return {
    deviceid: userInfo.deviceid,
    version: userInfo.appv,
    appVersion: userInfo.appv,
    serverversion: '6.3.5',
    plat: userInfo.plat,
    product: userInfo.product,
  };
}
// json参数转换string
function mParamToStr(params) {
  if (Object.prototype.toString.call(params) == '[object Object]') {
    const arr = [];
    for (const key in params) {
      const el = params[key];
      arr.push(`${key}=${el}`);
    }
    if (arr.length == 0) {
      return '';
    }
    return arr.join('&');
  }
  return params;
}
// 需要公共参数的请求
function mFetch(url, header, data, method = 'GET') {
  const newData = Object.assign(data, mCommonParams());
  return mFetchInternal(url, header, newData, method);
}
// 不需要公共参数的请求
function mFetchNoExtra(url, header, data, method = 'GET') {
  return mFetchInternal(url, header, data, method);
}
function mFetchInternal(url, header, data, method = 'GET') {
  return new Promise((resolve, reject) => {
    fund.request({
      url, // 仅为示例，并非真实接口地址。
      method,
      header,
      data,
      success: (res) => {
        resolve(res);
      },
      fail: () => {
        reject();
      },
    });
  });
}
export {
  mFetch,
  mFetchNoExtra, // 不需要公共参数
  mParamToStr, // 参数json转string
  mCommonParams, // 获取公共参数
};
